import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import { FeaturedProjectCard } from "./FeaturedProjectCard";
import colorSharp2 from "../assets/img/color-sharp2.webp";
import 'animate.css';
import TrackVisibility from 'react-on-screen';
import { featuredProjects, otherProjects } from "../data/content";

export const Projects = () => {
  return (
    <section className="project" id="projetos">
      <Container>
        <Row>
          <Col xs={12}>
            <TrackVisibility once>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn": ""}>
                <h2>Projetos</h2>
                <p>Produtos próprios, trabalhos para clientes e projetos pessoais. Alguns repositórios são privados, mas posso falar sobre eles em uma conversa.</p>
                <Tab.Container id="projects-tabs" defaultActiveKey="featured">
                  <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                    <Nav.Item>
                      <Nav.Link eventKey="featured">Destaques</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="others">Outros projetos</Nav.Link>
                    </Nav.Item>
                  </Nav>
                  <Tab.Content>
                    <Tab.Pane eventKey="featured">
                      <Row className="g-4">
                        {featuredProjects.map((project) => (
                          <FeaturedProjectCard key={project.title} {...project} />
                        ))}
                      </Row>
                    </Tab.Pane>
                    <Tab.Pane eventKey="others">
                      <Row>
                        {otherProjects.map((project) => (
                          <ProjectCard key={project.title} {...project} />
                        ))}
                      </Row>
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2} alt="" aria-hidden="true"></img>
    </section>
  )
}
